// extracted by mini-css-extract-plugin
export default {"form-wrapper":"EmailSignUp_form-wrapper__q3Ve5","text-button":"EmailSignUp_text-button__soWXU","link":"EmailSignUp_link__bfSXb"};